
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericClosedRight as ObiThreewayAcuatorGenericClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-closed-right.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericClosedRight = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-closed-right',
   elementClass: ObiThreewayAcuatorGenericClosedRightElement,
   events: {
     
   }
  });
 
 